import React, { Component } from "react";
import { connect } from "react-redux";
import * as actionTypes from "../../../store/Actions/actions";
import CloneICON from "../../../assets/images/clone.svg";
import cloneDeep from "lodash.clonedeep";
import * as UTILS from "../../../utils/Utils";

import TinyEditor from "./TinyEditor";

import shortid from "shortid";
import Popup from "../../Modal/Popup";
import Counter from "../../Tool/Counter/Counter";
import { emojiToUnicode } from "../TABLE/tableUtils";
import "./Text.scss";
// Font Family
let original_x = null;
let original_mouse_x = null;

class Text extends Component {
  _isMounted = false;
  constructor(props) {
    super(props);
    this.state = {
      fonts: [],
      id: null,
      editor: true,
      resize: null,
      editVidID: null,
      textContent: "",
      textEditorBlur: false,
    };
    // this.textAlignment = this.textAlignment.bind(this);
  }
  componentDidMount = () => {
    this.setState({
      textContent:
        this.props.textContent !== this.state.textContent &&
        this.props.textContent,
    });
  };

  setIdForEditHandler = (editID) => {
    this.setState({
      id: editID,
      resize: editID,
    });
  };

  handleQuillChange = (textValue) => {
    //     /* signal to React not to nullify the event object */
    // event.persist();
    // if (!this.debouncedFn) {
    //   this.debouncedFn =  _.debounce(() => {

    //   }, 300);
    // }
    // this.debouncedFn();
    let layout = cloneDeep(this.props.layout);

    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        item.text = textValue;
      },
      (colItem) => {
        colItem.text = textValue;
      },
      (colItemNested) => {
        colItemNested.text = textValue;
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };
  textLineHeight = (e, id) => {
    let textID = this.state.clickedID;
    let layout = cloneDeep(this.props.layout);
    let lineHeightVal = e.target.value;
    const newLayout = UTILS.UpdateLayout(
      layout,
      id,
      (item) => {
        item.style.lineHeight = lineHeightVal;
      },
      (colItem) => {
        colItem.style.lineHeight = lineHeightVal;
      },
      (colItemNested) => {
        colItemNested.style.lineHeight = lineHeightVal;
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);

    this.setState({
      addedElement: true,
    });
  };

  changeFontSize = (e, id) => {
    let layout = cloneDeep(this.props.layout);
    const selectedValue = e.target.value;

    const newLayout = UTILS.UpdateLayout(
      layout,
      id,
      (item) => {
        item.style.fontSize = selectedValue;
      },
      (colItem) => {
        colItem.style.fontSize = selectedValue;
      },
      (colItemNested) => {
        colItemNested.style.fontSize = selectedValue;
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };
  changefontfamily = (e, id) => {
    let layout = cloneDeep(this.props.layout);

    const newLayout = UTILS.UpdateLayout(
      layout,
      id,
      (item) => {
        item.style.fontFamily = e.target.value;
      },
      (colItem) => {
        colItem.style.fontFamily = e.target.value;
      },
      (colItemNested) => {
        colItemNested.style.fontFamily = e.target.value;
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };

  processElement = (item, value, property, viewType = "desktopStyle") => {
    if (!item[viewType]) { // if viewType is not defined, create it
      item[viewType] = {
        [property]: value,
      };
    } else if (Array.isArray(item[viewType])) { // if viewType is an array, convert it to an object
      item[viewType] = {
        [property]: value,
      };
    } else { // if viewType is an object, add the property and value
      item[viewType][property] = value;
    }
  }

  counterChange = (e, property) => {
    const layout = cloneDeep(this.props.layout);

    const selectedValue =
      e.target.value !== "" && e.target.value !== "0" && e.target.value !== "00"
        ? e.target.value.replace(/\b0+/g, "")
        : "0";

    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        this.processElement(item, selectedValue, property);
      },
      (colItem) => {
        this.processElement(colItem, selectedValue, property);
      },
      (colItemNested) => {
        this.processElement(colItemNested, selectedValue, property);
      }
    );

    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };
  counterPlus = (value, property) => {
    const layout = cloneDeep(this.props.layout);
    const selectedValue = value;
    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        this.processElement(item, JSON.stringify(JSON.parse(selectedValue) + 1), property);
      },
      (colItem) => {
        this.processElement(colItem, JSON.stringify(JSON.parse(selectedValue) + 1), property);
      },
      (colItemNested) => {
        this.processElement(colItemNested, JSON.stringify(JSON.parse(selectedValue) + 1), property);
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };

  counterMinus = (value, property) => {
    const layout = cloneDeep(this.props.layout);
    const selectedValue =
      property == "marginTop" ||
        property == "marginLeft" ||
        property == "marginRight" ||
        property == "marginBottom"
        ? value
        : value > 1
          ? value
          : "1";
    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        this.processElement(item, JSON.stringify(JSON.parse(selectedValue) - 1), property);
      },
      (colItem) => {
        this.processElement(colItem, JSON.stringify(JSON.parse(selectedValue) - 1), property);
      },
      (colItemNested) => {
        this.processElement(colItemNested, JSON.stringify(JSON.parse(selectedValue) - 1), property);
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };

  //***Mobile */
  counterChangeMobile = (e, property) => {
    const layout = cloneDeep(this.props.layout);

    const selectedValue =
      e.target.value !== "" && e.target.value !== "0" && e.target.value !== "00"
        ? e.target.value.replace(/\b0+/g, "")
        : "0";

    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        this.processElement(item, selectedValue, property, "mobileStyle");
      },
      (colItem) => {
        this.processElement(colItem, selectedValue, property, "mobileStyle");
      },
      (colItemNested) => {
        this.processElement(colItemNested, selectedValue, property, "mobileStyle");
      }
    );

    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };
  counterPlusMobile = (value, property) => {
    const layout = cloneDeep(this.props.layout);
    const selectedValue = value;
    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        this.processElement(item, JSON.stringify(JSON.parse(selectedValue) + 1), property, "mobileStyle");
      },
      (colItem) => {
        this.processElement(colItem, JSON.stringify(JSON.parse(selectedValue) + 1), property, "mobileStyle");
      },
      (colItemNested) => {
        this.processElement(colItemNested, JSON.stringify(JSON.parse(selectedValue) + 1), property, "mobileStyle");
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };

  counterMinusMobile = (value, property) => {
    const layout = cloneDeep(this.props.layout);
    const selectedValue =
      property == "marginTop" ||
        property == "marginLeft" ||
        property == "marginRight" ||
        property == "marginBottom"
        ? value
        : value > 1
          ? value
          : "1";
    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        this.processElement(item, JSON.stringify(JSON.parse(selectedValue) - 1), property, "mobileStyle");
      },
      (colItem) => {
        this.processElement(colItem, JSON.stringify(JSON.parse(selectedValue) - 1), property, "mobileStyle");
      },
      (colItemNested) => {
        this.processElement(colItemNested, JSON.stringify(JSON.parse(selectedValue) - 1), property, "mobileStyle");
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };
  formatText = (textVal, property, tag) => {
    var myString = textVal;
    // var myString = textVal;

    let elementID = "F" + shortid();
    var divElement = document.createElement("div");
    divElement.id = elementID;

    divElement.innerHTML = myString;

    if (divElement.getElementsByTagName(tag).length > 0) {
      var elements = divElement.getElementsByTagName("*");

      for (var i = 0; i < elements.length; i++) {
        // remove the style attribute enterily if it contains font-size property
        if ((elements[i].getAttribute("style") || "").includes(property)) {
          elements[i].style.removeProperty(property);
        }
      }
    }
    // loop through ALL DOM elements insidie the divElement
    // here is your font-size free string

    return emojiToUnicode(divElement.innerHTML);
    // return divElement.innerHTML
  };
  textAlignment = (value, device, textAlign) => {
    const layout = cloneDeep(this.props.layout);

    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        item.text = this.formatText(this.props.textContent, "text-align", "*");
        item[device] = { ...item[device], [textAlign]: value };
        item[device].listStylePosition =
          value == "center" || value == "right" ? "inside" : "outside";
      },
      (colItem) => {
        colItem.text = this.formatText(
          this.props.textContent,
          "text-align",
          "*"
        );
        colItem[device] = { ...colItem[device], [textAlign]: value };
        colItem[device].listStylePosition =
          value == "center" || value == "right" ? "inside" : "outside";
      },
      (colItemNested) => {
        colItemNested.text = this.formatText(
          this.props.textContent,
          "text-align",
          "*"
        );
        colItemNested[device] = {
          ...colItemNested[device],
          [textAlign]: value,
        };
        colItemNested[device].listStylePosition =
          value == "center" || value == "right" ? "inside" : "outside";
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };
  addTextLabel = (event) => {
    /* signal to React not to nullify the event object */
    event.persist();

    const layout = cloneDeep(this.props.layout);
    const selectedValue = event.target.value;
    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        item.label = selectedValue;
      },
      (colItem) => {
        colItem.label = selectedValue;
      },
      (colItemNested) => {
        colItemNested.label = selectedValue;
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };

  render() {
    const desktopStyle =
      !this.props.mobileView && this.props.element.desktopStyle
        ? {
          paddingTop: this.props.element.desktopStyle.paddingTop
            ? this.props.element.desktopStyle.paddingTop + "px"
            : "0",
          paddingRight: this.props.element.desktopStyle.paddingRight
            ? this.props.element.desktopStyle.paddingRight + "px"
            : "0",
          paddingBottom: this.props.element.desktopStyle.paddingBottom
            ? this.props.element.desktopStyle.paddingBottom + "px"
            : "0",
          paddingLeft: this.props.element.desktopStyle.paddingLeft
            ? this.props.element.desktopStyle.paddingLeft + "px"
            : "0",
          marginTop: this.props.element.desktopStyle.marginTop
            ? this.props.element.desktopStyle.marginTop + "px"
            : "0",
          marginRight: this.props.element.desktopStyle.marginRight
            ? this.props.element.desktopStyle.marginRight + "px"
            : "0",
          marginBottom: this.props.element.desktopStyle.marginBottom
            ? this.props.element.desktopStyle.marginBottom + "px"
            : "0",
          marginLeft: this.props.element.desktopStyle.marginLeft
            ? this.props.element.desktopStyle.marginLeft + "px"
            : "0",
          textAlign: this.props.element.desktopStyle.textAlign
            ? this.props.element.desktopStyle.textAlign
            : " ",
          listStylePosition: this.props.element.desktopStyle.listStylePosition
            ? this.props.element.desktopStyle.listStylePosition
            : " ",
        }
        : {};
    const mobileStyle =
      this.props.mobileView && this.props.element.mobileStyle
        ? {
          paddingTop: this.props.element.mobileStyle.paddingTop
            ? this.props.element.mobileStyle.paddingTop + "px"
            : "0",
          paddingRight: this.props.element.mobileStyle.paddingRight
            ? this.props.element.mobileStyle.paddingRight + "px"
            : "0",
          paddingBottom: this.props.element.mobileStyle.paddingBottom
            ? this.props.element.mobileStyle.paddingBottom + "px"
            : "0",
          paddingLeft: this.props.element.mobileStyle.paddingLeft
            ? this.props.element.mobileStyle.paddingLeft + "px"
            : "0",
          marginTop: this.props.element.mobileStyle.marginTop
            ? this.props.element.mobileStyle.marginTop + "px"
            : "0",
          marginRight: this.props.element.mobileStyle.marginRight
            ? this.props.element.mobileStyle.marginRight + "px"
            : "0",
          marginBottom: this.props.element.mobileStyle.marginBottom
            ? this.props.element.mobileStyle.marginBottom + "px"
            : "0",
          marginLeft: this.props.element.mobileStyle.marginLeft
            ? this.props.element.mobileStyle.marginLeft + "px"
            : "0",
          textAlign: this.props.element.mobileStyle.textAlign
            ? this.props.element.mobileStyle.textAlign
            : " ",
          listStylePosition: this.props.element.mobileStyle.listStylePosition
            ? this.props.element.mobileStyle.listStylePosition
            : " ",
        }
        : {};
    const textFont =
      this.props.fontName && this.props.fontName !== "inherit"
        ? { fontFamily: this.props.fontName }
        : {};

    return (
      <div className="text-wrapper">
        <div className="actionControl">
          <button
            className="button text-setting"
            onClick={() => {
              this.setState(
                {
                  editVidID: this.props.ID,
                },
                () => {
                  const layout = cloneDeep(this.props.layout);
                  const isDeskStyle = this.props.element.desktopStyle
                    ? true
                    : false;

                  const newLayout = UTILS.UpdateLayout(
                    layout,
                    this.props.ID,
                    (item) => {
                      item.desktopStyle = {};
                      item.mobileStyle = {};
                    },
                    (colItem) => {
                      colItem.desktopStyle = {};
                      colItem.mobileStyle = {};
                    },
                    (colItemNested) => {
                      colItemNested.desktopStyle = {};
                      colItemNested.mobileStyle = {};
                    }
                  );

                  !isDeskStyle
                    ? this.props.layoutArray(this.props.layoutTitle, newLayout)
                    : null;
                }
              );
            }}
          >
            Text Settings
          </button>
          <button className="clone-item" onClick={() => { this.props.cloneElement(this.props.element.id) }}>
            <img src={CloneICON} />
          </button>

          <span className="delete-item" onClick={() => { this.props.deleteElement(this.props.element.id) }}>
            <i className="far fa-trash-alt" />
          </span>
          <span
            className="textAlignIcon"
            style={{
              backgroundImage: "none",
              lineHeight: "15px",
              textIndent: "0",
            }}
          >
            <i className="fas fa-align-center"></i>
            <ul className="alignmentOptions">
              <li>
                <span
                  className="textAlignIcon"
                  style={{ backgroundImage: "none", textIndent: "0" }}
                >
                  <i className="fas fa-desktop"></i>
                </span>
                <span
                  className={
                    this.props.element.desktopStyle &&
                      this.props.element.desktopStyle.textAlign == "left"
                      ? this.props.element.desktopStyle.textAlign
                      : ""
                  }
                  onClick={() => {
                    this.textAlignment("left", "desktopStyle", "textAlign");
                  }}
                >
                  <i className="fas fa-align-left"></i>
                </span>
                <span
                  className={
                    this.props.element.desktopStyle &&
                      this.props.element.desktopStyle.textAlign == "center"
                      ? this.props.element.desktopStyle.textAlign
                      : ""
                  }
                  onClick={() => {
                    this.textAlignment("center", "desktopStyle", "textAlign");
                  }}
                >
                  <i className="fas fa-align-center"></i>
                </span>
                <span
                  className={
                    this.props.element.desktopStyle &&
                      this.props.element.desktopStyle.textAlign == "right"
                      ? this.props.element.desktopStyle.textAlign
                      : ""
                  }
                  onClick={() => {
                    this.textAlignment("right", "desktopStyle", "textAlign");
                  }}
                >
                  <i className="fas fa-align-right"></i>
                </span>
                <span
                  className={
                    this.props.element.desktopStyle &&
                      this.props.element.desktopStyle.textAlign == "justify"
                      ? this.props.element.desktopStyle.textAlign
                      : ""
                  }
                  onClick={() => {
                    this.textAlignment("justify", "desktopStyle", "textAlign");
                  }}
                >
                  <i className="fas fa-align-justify"></i>
                </span>
              </li>
              <li>
                <span
                  className="textAlignIcon"
                  style={{ backgroundImage: "none", textIndent: "0" }}
                >
                  <i className="fas fa-mobile-alt"></i>
                </span>
                <span
                  className={
                    this.props.element.mobileStyle &&
                      this.props.element.mobileStyle.textAlign == "left"
                      ? this.props.element.mobileStyle.textAlign
                      : " "
                  }
                  onClick={() => {
                    this.textAlignment("left", "mobileStyle", "textAlign");
                  }}
                >
                  <i className="fas fa-align-left"></i>
                </span>
                <span
                  className={
                    this.props.element.mobileStyle &&
                      this.props.element.mobileStyle.textAlign == "center"
                      ? this.props.element.mobileStyle.textAlign
                      : " "
                  }
                  onClick={() => {
                    this.textAlignment("center", "mobileStyle", "textAlign");
                  }}
                >
                  <i className="fas fa-align-center"></i>
                </span>
                <span
                  className={
                    this.props.element.mobileStyle &&
                      this.props.element.mobileStyle.textAlign == "right"
                      ? this.props.element.mobileStyle.textAlign
                      : " "
                  }
                  onClick={() => {
                    this.textAlignment("right", "mobileStyle", "textAlign");
                  }}
                >
                  <i className="fas fa-align-right"></i>
                </span>
                <span
                  className={
                    this.props.element.mobileStyle &&
                      this.props.element.mobileStyle.textAlign == "justify"
                      ? this.props.element.mobileStyle.textAlign
                      : " "
                  }
                  onClick={() => {
                    this.textAlignment("justify", "mobileStyle", "textAlign");
                  }}
                >
                  <i className="fas fa-align-justify"></i>
                </span>
              </li>
            </ul>
          </span>
        </div>

        {this.state.editVidID && (
          <Popup
            width="700"
            header="Text Settings"
            close={() => {
              this.setState({
                editVidID: !this.state.editVidID,
              });
            }}
            closePopup={() => {
              this.setState({
                editVidID: !this.state.editVidID,
              });
            }}
          >
            <div className="modalScrollContainerSecondary">
              <div className="modalContentWrapper">
                <label>
                  Text Label <small> (For Meta Data and Aria Labels)</small>
                </label>
                <input
                  onChange={this.addTextLabel}
                  defaultValue={this.props.label}
                  placeholder="Add Text Label"
                  className="textLabelInput"
                  type="text"
                />
              </div>
              <div
                style={{ marginTop: "30px", marginBottom: "5px" }}
                className="padding-section"
              >
                <div className="heading">Padding</div>
              </div>
              <div
                className="modalContentWrapper"
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <div
                  style={{
                    width: "50%",
                    display: "flex",
                    flexDirection: "column",
                    flexWrap: "flex",
                  }}
                >
                  <div className="heading-row">
                    <div>Desktop</div>
                  </div>
                  <div style={{ display: "flex", flexDirection: "row" }}>
                    <div className="d-block">
                      <Counter
                        label="Top"
                        small={
                          this.state.canvasPaddingUnit === "%"
                            ? "percent"
                            : "pixel"
                        }
                        minusClick={() =>
                          this.counterMinus(
                            this.props.element.desktopStyle &&
                              this.props.element.desktopStyle.paddingTop
                              ? this.props.element.desktopStyle.paddingTop
                              : "0",
                            "paddingTop"
                          )
                        }
                        valueContent={
                          this.props.element.desktopStyle &&
                            this.props.element.desktopStyle.paddingTop
                            ? this.props.element.desktopStyle.paddingTop
                            : "0"
                        }
                        disabled={false}
                        onChange={(e) => {
                          this.counterChange(e, "paddingTop");
                        }}
                        plusClick={() => {
                          this.counterPlus(
                            this.props.element.desktopStyle &&
                              this.props.element.desktopStyle.paddingTop
                              ? this.props.element.desktopStyle.paddingTop
                              : "0",
                            "paddingTop"
                          );
                        }}
                      />
                    </div>
                    <div className="d-block">
                      <Counter
                        label="Left"
                        small={
                          this.state.canvasPaddingUnit === "%"
                            ? "percent"
                            : "pixel"
                        }
                        minusClick={() =>
                          this.counterMinus(
                            this.props.element.desktopStyle &&
                              this.props.element.desktopStyle.paddingLeft
                              ? this.props.element.desktopStyle.paddingLeft
                              : "0",
                            "paddingLeft"
                          )
                        }
                        valueContent={
                          this.props.element.desktopStyle &&
                            this.props.element.desktopStyle.paddingLeft
                            ? this.props.element.desktopStyle.paddingLeft
                            : "0"
                        }
                        disabled={false}
                        onChange={(e) => {
                          this.counterChange(e, "paddingLeft");
                        }}
                        plusClick={() =>
                          this.counterPlus(
                            this.props.element.desktopStyle &&
                              this.props.element.desktopStyle.paddingLeft
                              ? this.props.element.desktopStyle.paddingLeft
                              : "0",
                            "paddingLeft"
                          )
                        }
                      />
                    </div>
                  </div>
                  <div style={{ display: "flex", flexDirection: "row" }}>
                    <div className="d-block">
                      <Counter
                        label="Bottom"
                        small={
                          this.state.canvasPaddingUnit === "%"
                            ? "percent"
                            : "pixel"
                        }
                        minusClick={() =>
                          this.counterMinus(
                            this.props.element.desktopStyle &&
                              this.props.element.desktopStyle.paddingBottom
                              ? this.props.element.desktopStyle.paddingBottom
                              : "0",
                            "paddingBottom"
                          )
                        }
                        valueContent={
                          this.props.element.desktopStyle &&
                            this.props.element.desktopStyle.paddingBottom
                            ? this.props.element.desktopStyle.paddingBottom
                            : "0"
                        }
                        disabled={false}
                        onChange={(e) => {
                          this.counterChange(e, "paddingBottom");
                        }}
                        plusClick={() =>
                          this.counterPlus(
                            this.props.element.desktopStyle &&
                              this.props.element.desktopStyle.paddingBottom
                              ? this.props.element.desktopStyle.paddingBottom
                              : "0",
                            "paddingBottom"
                          )
                        }
                      />
                    </div>
                    <div className="d-block">
                      <Counter
                        label="Right"
                        small={
                          this.state.canvasPaddingUnit === "%"
                            ? "percent"
                            : "pixel"
                        }
                        minusClick={() =>
                          this.counterMinus(
                            this.props.element.desktopStyle &&
                              this.props.element.desktopStyle.paddingRight
                              ? this.props.element.desktopStyle.paddingRight
                              : "0",
                            "paddingRight"
                          )
                        }
                        valueContent={
                          this.props.element.desktopStyle &&
                            this.props.element.desktopStyle.paddingRight
                            ? this.props.element.desktopStyle.paddingRight
                            : "0"
                        }
                        disabled={false}
                        onChange={(e) => {
                          this.counterChange(e, "paddingRight");
                        }}
                        plusClick={() =>
                          this.counterPlus(
                            this.props.element.desktopStyle &&
                              this.props.element.desktopStyle.paddingRight
                              ? this.props.element.desktopStyle.paddingRight
                              : "0",
                            "paddingRight"
                          )
                        }
                      />
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    width: "50%",
                    display: "flex",
                    flexDirection: "column",
                    flexWrap: "flex",
                  }}
                >
                  <div className="heading-row">
                    <div>Mobile</div>
                  </div>
                  <div style={{ display: "flex", flexDirection: "row" }}>
                    <div className="d-block">
                      <Counter
                        label="Top"
                        small={
                          this.state.canvasPaddingUnit === "%"
                            ? "percent"
                            : "pixel"
                        }
                        minusClick={() =>
                          this.counterMinusMobile(
                            this.props.element.mobileStyle &&
                              this.props.element.mobileStyle.paddingTop
                              ? this.props.element.mobileStyle.paddingTop
                              : "0",
                            "paddingTop"
                          )
                        }
                        valueContent={
                          this.props.element.mobileStyle &&
                            this.props.element.mobileStyle.paddingTop
                            ? this.props.element.mobileStyle.paddingTop
                            : "0"
                        }
                        disabled={false}
                        onChange={(e) => {
                          this.counterChangeMobile(e, "paddingTop");
                        }}
                        plusClick={() => {
                          this.counterPlusMobile(
                            this.props.element.mobileStyle &&
                              this.props.element.mobileStyle.paddingTop
                              ? this.props.element.mobileStyle.paddingTop
                              : "0",
                            "paddingTop"
                          );
                        }}
                      />
                    </div>
                    <div className="d-block">
                      <Counter
                        label="Left"
                        small={
                          this.state.canvasPaddingUnit === "%"
                            ? "percent"
                            : "pixel"
                        }
                        minusClick={() =>
                          this.counterMinusMobile(
                            this.props.element.mobileStyle &&
                              this.props.element.mobileStyle.paddingLeft
                              ? this.props.element.mobileStyle.paddingLeft
                              : "0",
                            "paddingLeft"
                          )
                        }
                        valueContent={
                          this.props.element.mobileStyle &&
                            this.props.element.mobileStyle.paddingLeft
                            ? this.props.element.mobileStyle.paddingLeft
                            : "0"
                        }
                        disabled={false}
                        onChange={(e) => {
                          this.counterChangeMobile(e, "paddingLeft");
                        }}
                        plusClick={() =>
                          this.counterPlusMobile(
                            this.props.element.mobileStyle &&
                              this.props.element.mobileStyle.paddingLeft
                              ? this.props.element.mobileStyle.paddingLeft
                              : "0",
                            "paddingLeft"
                          )
                        }
                      />
                    </div>
                  </div>

                  <div style={{ display: "flex", flexDirection: "row" }}>
                    <div className="d-block">
                      <Counter
                        label="Bottom"
                        small={
                          this.state.canvasPaddingUnit === "%"
                            ? "percent"
                            : "pixel"
                        }
                        minusClick={() =>
                          this.counterMinusMobile(
                            this.props.element.mobileStyle &&
                              this.props.element.mobileStyle.paddingBottom
                              ? this.props.element.mobileStyle.paddingBottom
                              : "0",
                            "paddingBottom"
                          )
                        }
                        valueContent={
                          this.props.element.mobileStyle &&
                            this.props.element.mobileStyle.paddingBottom
                            ? this.props.element.mobileStyle.paddingBottom
                            : "0"
                        }
                        disabled={false}
                        onChange={(e) => {
                          this.counterChangeMobile(e, "paddingBottom");
                        }}
                        plusClick={() =>
                          this.counterPlusMobile(
                            this.props.element.mobileStyle &&
                              this.props.element.mobileStyle.paddingBottom
                              ? this.props.element.mobileStyle.paddingBottom
                              : "0",
                            "paddingBottom"
                          )
                        }
                      />
                    </div>
                    <div className="d-block">
                      <Counter
                        label="Right"
                        small={
                          this.state.canvasPaddingUnit === "%"
                            ? "percent"
                            : "pixel"
                        }
                        minusClick={() =>
                          this.counterMinusMobile(
                            this.props.element.mobileStyle &&
                              this.props.element.mobileStyle.paddingRight
                              ? this.props.element.mobileStyle.paddingRight
                              : "0",
                            "paddingRight"
                          )
                        }
                        valueContent={
                          this.props.element.mobileStyle &&
                            this.props.element.mobileStyle.paddingRight
                            ? this.props.element.mobileStyle.paddingRight
                            : "0"
                        }
                        disabled={false}
                        onChange={(e) => {
                          this.counterChangeMobile(e, "paddingRight");
                        }}
                        plusClick={() =>
                          this.counterPlusMobile(
                            this.props.element.mobileStyle &&
                              this.props.element.mobileStyle.paddingRight
                              ? this.props.element.mobileStyle.paddingRight
                              : "0",
                            "paddingRight"
                          )
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* MARGIN */}
              <div
                style={{ marginTop: "30px", marginBottom: "5px" }}
                className="padding-section"
              >
                <div className="heading">Margin</div>
              </div>

              <div
                className="modalContentWrapper"
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <div
                  style={{
                    width: "50%",
                    display: "flex",
                    flexDirection: "column",
                    flexWrap: "flex",
                  }}
                >
                  <div className="heading-row">Desktop</div>
                  <div style={{ display: "flex", flexDirection: "row" }}>
                    <div className="d-block">
                      <Counter
                        label="Top"
                        small={
                          this.state.canvasPaddingUnit === "%"
                            ? "percent"
                            : "pixel"
                        }
                        minusClick={() =>
                          this.counterMinus(
                            this.props.element.desktopStyle &&
                              this.props.element.desktopStyle.marginTop
                              ? this.props.element.desktopStyle.marginTop
                              : "0",
                            "marginTop"
                          )
                        }
                        valueContent={
                          this.props.element.desktopStyle &&
                            this.props.element.desktopStyle.marginTop
                            ? this.props.element.desktopStyle.marginTop
                            : "0"
                        }
                        disabled={false}
                        onChange={(e) => {
                          this.counterChange(e, "marginTop");
                        }}
                        plusClick={() => {
                          this.counterPlus(
                            this.props.element.desktopStyle &&
                              this.props.element.desktopStyle.marginTop
                              ? this.props.element.desktopStyle.marginTop
                              : "0",
                            "marginTop"
                          );
                        }}
                      />
                    </div>
                    <div className="d-block">
                      <Counter
                        label="Left"
                        small={
                          this.state.canvasPaddingUnit === "%"
                            ? "percent"
                            : "pixel"
                        }
                        minusClick={() =>
                          this.counterMinus(
                            this.props.element.desktopStyle &&
                              this.props.element.desktopStyle.marginLeft
                              ? this.props.element.desktopStyle.marginLeft
                              : "0",
                            "marginLeft"
                          )
                        }
                        valueContent={
                          this.props.element.desktopStyle &&
                            this.props.element.desktopStyle.marginLeft
                            ? this.props.element.desktopStyle.marginLeft
                            : "0"
                        }
                        disabled={false}
                        onChange={(e) => {
                          this.counterChange(e, "marginLeft");
                        }}
                        plusClick={() =>
                          this.counterPlus(
                            this.props.element.desktopStyle &&
                              this.props.element.desktopStyle.marginLeft
                              ? this.props.element.desktopStyle.marginLeft
                              : "0",
                            "marginLeft"
                          )
                        }
                      />
                    </div>
                  </div>
                  <div style={{ display: "flex", flexDirection: "row" }}>
                    <div className="d-block">
                      <Counter
                        label="Bottom"
                        small={
                          this.state.canvasPaddingUnit === "%"
                            ? "percent"
                            : "pixel"
                        }
                        minusClick={() =>
                          this.counterMinus(
                            this.props.element.desktopStyle &&
                              this.props.element.desktopStyle.marginBottom
                              ? this.props.element.desktopStyle.marginBottom
                              : "0",
                            "marginBottom"
                          )
                        }
                        valueContent={
                          this.props.element.desktopStyle &&
                            this.props.element.desktopStyle.marginBottom
                            ? this.props.element.desktopStyle.marginBottom
                            : "0"
                        }
                        disabled={false}
                        onChange={(e) => {
                          this.counterChange(e, "marginBottom");
                        }}
                        plusClick={() =>
                          this.counterPlus(
                            this.props.element.desktopStyle &&
                              this.props.element.desktopStyle.marginBottom
                              ? this.props.element.desktopStyle.marginBottom
                              : "0",
                            "marginBottom"
                          )
                        }
                      />
                    </div>
                    <div className="d-block">
                      <Counter
                        label="Right"
                        small={
                          this.state.canvasPaddingUnit === "%"
                            ? "percent"
                            : "pixel"
                        }
                        minusClick={() =>
                          this.counterMinus(
                            this.props.element.desktopStyle &&
                              this.props.element.desktopStyle.marginRight
                              ? this.props.element.desktopStyle.marginRight
                              : "0",
                            "marginRight"
                          )
                        }
                        valueContent={
                          this.props.element.desktopStyle &&
                            this.props.element.desktopStyle.marginRight
                            ? this.props.element.desktopStyle.marginRight
                            : "0"
                        }
                        disabled={false}
                        onChange={(e) => {
                          this.counterChange(e, "marginRight");
                        }}
                        plusClick={() =>
                          this.counterPlus(
                            this.props.element.desktopStyle &&
                              this.props.element.desktopStyle.marginRight
                              ? this.props.element.desktopStyle.marginRight
                              : "0",
                            "marginRight"
                          )
                        }
                      />
                    </div>
                  </div>
                </div>

                <div
                  style={{
                    width: "50%",
                    display: "flex",
                    flexDirection: "column",
                    flexWrap: "flex",
                  }}
                >
                  <div className="heading-row">Mobile</div>
                  <div style={{ display: "flex", flexDirection: "row" }}>
                    <div className="d-block">
                      <Counter
                        label="Top"
                        small={
                          this.state.canvasPaddingUnit === "%"
                            ? "percent"
                            : "pixel"
                        }
                        minusClick={() =>
                          this.counterMinusMobile(
                            this.props.element.mobileStyle &&
                              this.props.element.mobileStyle.marginTop
                              ? this.props.element.mobileStyle.marginTop
                              : "0",
                            "marginTop"
                          )
                        }
                        valueContent={
                          this.props.element.mobileStyle &&
                            this.props.element.mobileStyle.marginTop
                            ? this.props.element.mobileStyle.marginTop
                            : "0"
                        }
                        disabled={false}
                        onChange={(e) => {
                          this.counterChangeMobile(e, "marginTop");
                        }}
                        plusClick={() => {
                          this.counterPlusMobile(
                            this.props.element.mobileStyle &&
                              this.props.element.mobileStyle.marginTop
                              ? this.props.element.mobileStyle.marginTop
                              : "0",
                            "marginTop"
                          );
                        }}
                      />
                    </div>
                    <div className="d-block">
                      <Counter
                        label="Left"
                        small={
                          this.state.canvasPaddingUnit === "%"
                            ? "percent"
                            : "pixel"
                        }
                        minusClick={() =>
                          this.counterMinusMobile(
                            this.props.element.mobileStyle &&
                              this.props.element.mobileStyle.marginLeft
                              ? this.props.element.mobileStyle.marginLeft
                              : "0",
                            "marginLeft"
                          )
                        }
                        valueContent={
                          this.props.element.mobileStyle &&
                            this.props.element.mobileStyle.marginLeft
                            ? this.props.element.mobileStyle.marginLeft
                            : "0"
                        }
                        disabled={false}
                        onChange={(e) => {
                          this.counterChangeMobile(e, "marginLeft");
                        }}
                        plusClick={() =>
                          this.counterPlusMobile(
                            this.props.element.mobileStyle &&
                              this.props.element.mobileStyle.marginLeft
                              ? this.props.element.mobileStyle.marginLeft
                              : "0",
                            "marginLeft"
                          )
                        }
                      />
                    </div>
                  </div>
                  <div style={{ display: "flex", flexDirection: "row" }}>
                    <div className="d-block">
                      <Counter
                        label="Bottom"
                        small={
                          this.state.canvasmarginUnit === "%"
                            ? "percent"
                            : "pixel"
                        }
                        minusClick={() =>
                          this.counterMinusMobile(
                            this.props.element.mobileStyle &&
                              this.props.element.mobileStyle.marginBottom
                              ? this.props.element.mobileStyle.marginBottom
                              : "0",
                            "marginBottom"
                          )
                        }
                        valueContent={
                          this.props.element.mobileStyle &&
                            this.props.element.mobileStyle.marginBottom
                            ? this.props.element.mobileStyle.marginBottom
                            : "0"
                        }
                        disabled={false}
                        onChange={(e) => {
                          this.counterChangeMobile(e, "marginBottom");
                        }}
                        plusClick={() =>
                          this.counterPlusMobile(
                            this.props.element.mobileStyle &&
                              this.props.element.mobileStyle.marginBottom
                              ? this.props.element.mobileStyle.marginBottom
                              : "0",
                            "marginBottom"
                          )
                        }
                      />
                    </div>

                    <Counter
                      label="Right"
                      small={
                        this.state.canvasPaddingUnit === "%"
                          ? "percent"
                          : "pixel"
                      }
                      minusClick={() =>
                        this.counterMinusMobile(
                          this.props.element.mobileStyle &&
                            this.props.element.mobileStyle.marginRight
                            ? this.props.element.mobileStyle.marginRight
                            : "0",
                          "marginRight"
                        )
                      }
                      valueContent={
                        this.props.element.mobileStyle &&
                          this.props.element.mobileStyle.marginRight
                          ? this.props.element.mobileStyle.marginRight
                          : "0"
                      }
                      disabled={false}
                      onChange={(e) => {
                        this.counterChangeMobile(e, "marginRight");
                      }}
                      plusClick={() =>
                        this.counterPlusMobile(
                          this.props.element.mobileStyle &&
                            this.props.element.mobileStyle.marginRight
                            ? this.props.element.mobileStyle.marginRight
                            : "0",
                          "marginRight"
                        )
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          </Popup>
        )}
        {/* +
              (this.props.mobileView && this.props.element.mobileStyle ? this.props.element.mobileStyle:{}) +
              (!this.props.mobileView && this.props.element.desktopStyle ? this.props.element.desktopStyle:{}) */}

        <div
          className="tinyWrapper"
          style={{ ...desktopStyle, ...mobileStyle, ...textFont }}
          key={this.props.ID}
        >
          <TinyEditor
            mobileView={this.props.mobileView}
            pagesList={this.props.pagesList}
            ID={"text-element" + this.props.ID}
            element={this.props.element}
            textContent={this.props.textContent}
            onEditorChange={this.handleQuillChange}
            preset={this.props.preset}
            elementsFont={this.props.elementsFont}
            selectedFont={this.props.selectedFont}
          />
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    layout: state.present.layout,
    layoutTitle: state.present.layoutTitle,
    canvasStyle: state.present.canvasStyle,
    elementsFont: state.present.canvasStyle.elementsFont,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    layoutArray: (titleValue, layoutVal) =>
      dispatch(
        actionTypes.layout({ titleLayout: titleValue, layout: layoutVal })
      ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Text);
